import React from "react";
import { Trans } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useGetProductsQuery } from "../../../api";
import { Icon } from "../../../components/simple/Icon";
import { PRODUCTS_IMG_URLS } from "../../../helpers/history";

export const Index = () => {
  const {
    state: { type = "error", productType = "", productTypes = [] },
  } = useLocation();
  const { data, isLoading, isError, error } = useGetProductsQuery();

  return (
    <main className="container">
      <div className="request-form mt-80 pb-128">
        <div className="message-request text-center  mb-128">
          <div className="message-request-result">
            <i>
              {type === "success" ? (
                <Icon name="icn-success" view="0 0 48 48" />
              ) : (
                <Icon name="error" view="0 0 64 64" />
              )}
            </i>
          </div>
          {/* <img className="mb-32" src="/images/icons/tick.png" alt="" /> */}
          <h4 className="productive-heading-04 mb-16">
            <Trans i18nKey={`Notification.${type}.title`} />
          </h4>
          <p className="">
            <Trans i18nKey={`Notification.${type}.description`} />
          </p>
        </div>
        <div>
          {!isLoading && !isError && (
            <>
              <h4 className="productive-heading-04 mb-64 text-center">
                <Trans i18nKey="Common.Other.Products" />
              </h4>

              <div
                className={`img-container img-${
                  PRODUCTS_IMG_URLS.filter(
                    (i) =>
                      (productType && i.key !== productType) ||
                      (productTypes.length && !productTypes.includes(i.key))
                  ).length
                }`}>
                {PRODUCTS_IMG_URLS.filter(
                  (i) =>
                    (productType && i.key !== productType) ||
                    (productTypes.length && !productTypes.includes(i.key))
                ).map(
                  (product) =>
                    data.includes(product.key) && (
                      <Link
                        to={`/application/create/${product.key.toLowerCase()}`}>
                        <img
                          key={`product-${product.key}`}
                          src={product.img}
                          alt=""
                        />
                        <p className="img-descriptioin">
                          <Trans
                            i18nKey={`Product.${product.key.toLowerCase()}`}
                          />
                        </p>
                      </Link>
                    )
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
};
